import type { components, paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation } from "@tanstack/react-query";

export const DATA_EXPORT_RESOURCE = "data-export" as const;
export const DATA_EXPORT_API_PATH = `/v1/${DATA_EXPORT_RESOURCE}` as const;

export type DataExportRequested = components["schemas"]["DataExportRequestedDto"];
export type DataExportCreateBody =
  paths[typeof DATA_EXPORT_API_PATH]["post"]["requestBody"]["content"]["application/json"];

export const useDataExportCreateMutation = () =>
  useMutation<DataExportRequested, Error, DataExportCreateBody>({
    mutationFn: async (body) => {
      const response = await alphartisApiAxios.post<DataExportRequested>(DATA_EXPORT_API_PATH, body);
      return response.data;
    },
  });
